<template>
  <div>
    <qx-card title="客户" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      >
        <span slot="problemPrice" slot-scope="prop">
          {{ (prop.data.problemPrice / 100).toFixed(2) }}元
        </span>
        <span slot="problemTypeName" slot-scope="prop">
          {{ prop.data.problemTypeName }}
          <span class="error" v-if="prop.data.probelmTypeDesc">
            （{{ prop.data.probelmTypeDesc }}）
          </span>
        </span>
        <span slot="carOwnerName" slot-scope="prop">
          {{ prop.data.carOwnerName }}（{{ prop.data.carOwnerPhone }}）
        </span>
      </qx-detail-box>
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      ref="approveBox"
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="300001"
      :customBaseform="baseForm"
      :customPost="customPost"
      @sub="sub"
      :inFast="Boolean(id)"
      :handleRefresh="handleRefresh"
    />
  </div>
</template>

<script>
import {
  approveItemInfo,
} from 'api';
import {
  orderUnusualRegisterDetail, // 获取详情
  orderOverviewDetail,
  orderUnusualRegisterApprove,
} from 'api/operate';
import {
  isExist,
} from '@qx/utils/index';
import ApproveBox from 'components/approveBox';
export default {
  components: {
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      orderId: '',
      // 自定义提交
      customPost: true,
      loading: false,
      detailData: {
        base: {
          label: '异常信息',
          tableData: {
            title: [
              {
                prop: 'orderId',
                label: '订单编号',
              },
              {
                prop: 'sourceProblemName',
                label: '异常来源',
              },
              {
                prop: 'statusName',
                label: '订单状态',
              },
              {
                prop: 'receiveTenantName',
                label: '接单车队',
              },
              {
                prop: 'orderTypeName',
                label: '订单来源',
              },
              {
                prop: 'fromTenantName',
                label: '转单车队',
              },
              {
                prop: 'problemTypeName',
                label: '异常类型',
                slot: true,
              },
              {
                prop: 'problemPrice',
                label: '登记金额',
                slot: true,
              },
              {
                prop: 'carOwnerName',
                label: '责任司机',
                slot: true,
              },
              {
                prop: 'problemDesc',
                label: '异常描述',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
      // 由于比常见的审核表单多了一个字段，所以以自定义的方式插入组件
      baseForm: {
        form: [
          {
            label: '审核结果',
            value: 'chooseResult',
            type: 'radio',
            width: '200px',
            default: 1,
            options: [
              {
                label: '通过',
                value: 1,
              },
              {
                label: '不通过',
                value: 2,
              },
            ],
            onChange: () => {
              const chooseResult = this.$refs.approveBox.$refs.baseForm.getVal('chooseResult');
              // 如果通过，调用异常登记审核通过接口，参数也要改名；如果不通过，调用之前的审核不通过接口
              this.customPost = !!(chooseResult === 1);

              this.setFormAttrVal({
                form: this.baseForm,
                attr: 'hide',
                value: !!(chooseResult === 2),
                names: ['problemDealPrice'],
              });
            },
          },
          {
            label: '处理金额',
            value: 'problemDealPrice',
            type: 'input',
            unit: '元',
            hide: false,
            onInput: () => {
              const baseForm = this.$refs.approveBox.$refs.baseForm;
              const problemDealPrice = baseForm.getVal('problemDealPrice');
              baseForm.setVal('problemDealPrice', problemDealPrice.replace(/\-/g, ''));
            },
          },
          {
            label: '审核意见',
            value: 'desc',
            type: 'input',
            width: '430px',
            attr: {
              type: 'textarea',
              limit: 300,
            },
          },
        ],
        rules: {
          chooseResult: [ // 审核结果
            { required: true, message: '请选择审核结果', trigger: 'blur' },
          ],
        },
      },
    };
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    async getData () {
      if (this.$route.path !== '/manage/operate/order/deal/orderDetailTab/unusual/detail' && !this.id) {
        return;
      }
      this.customPost = true;

      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: false,
        names: ['problemDealPrice'],
      });

      this.loading = true;
      const detailRes = await orderUnusualRegisterDetail({
        problemId: this.id || this.$route.query.id,
      });
      const orderRes = await orderOverviewDetail({
        orderId: this.orderId || this.$route.query.orderId,
      });
      this.loading = false;
      if (!detailRes.failed) {
        let problemDealPrice = '0.00';
        if (isExist(detailRes.problemDealPrice)) {
          problemDealPrice = (detailRes.problemDealPrice / 100).toFixed(2);
        } else {
          let problemPrice = detailRes.problemPrice;
          if ((problemPrice)) {
            if (problemPrice < 0) {
              problemPrice = 0 - problemPrice;
            }
            problemPrice = (problemPrice / 100).toFixed(2);
          }
          detailRes.problemDealPrice = problemPrice;
          problemDealPrice = problemPrice;
        }

        if (this.$route.query.type === 'approve' || this.id) {
          this.$nextTick(() => {
            this.$refs.approveBox.$refs.baseForm.setVal('problemDealPrice', problemDealPrice);
          });
        }

        this.detailData.base.tableData.data = {
          ...orderRes,
          ...detailRes,
        };
      }
    },
    async sub (formData) {
      if (formData) {
        if (formData.chooseResult === 1) {
          // 如果通过，调用 审核异常审核接口，同时参数也要改变
          const detailData = this.detailData.base.tableData.data;
          const params = {
            state: formData.chooseResult,
            verifyDesc: formData.desc,
            problemState: detailData.state,
            problemDealPrice: this.$refs.approveBox.$refs.baseForm.getVal('problemDealPrice'),
            problemPrice: detailData.problemPrice,
            problemId: detailData.problemId,
          };
          const res = await orderUnusualRegisterApprove(params);
          if (!res.failed) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.close();
          }
        }
      }
    },
  },
  async mounted () {
    if (this.id) {
      const res = await approveItemInfo({
        busiId: this.id,
        busiCode: 300001,
      });
      this.orderId = res.orderId;
    }
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/config.scss';
.orderStatusBox {
  overflow: auto;
}
.orderInfoBox {
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,
  .time {
    color: #666;
    line-height: 16px;
  }
  .desc {
    padding-bottom: 12px;
  }
}
.box {
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel {
  background: $grey;
}
.itemLabel,
.itemText {
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
